import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type CustomerRetailPriceRecordFieldsFragment = { __typename?: 'CustomerRetailPriceRecord', customerItemId: string, price?: number | null, currency?: string | null, effectiveFrom?: Types.TDateISO | null, effectiveUntil?: Types.TDateISO | null, fromDate?: string | null, throughDate?: string | null };

export type CustomerRetailPriceFieldsFragment = { __typename?: 'CustomerRetailPrice', itemId: string, baselineToken: string, current?: { __typename?: 'CustomerRetailPriceRecord', customerItemId: string, price?: number | null, currency?: string | null, effectiveFrom?: Types.TDateISO | null, effectiveUntil?: Types.TDateISO | null, fromDate?: string | null, throughDate?: string | null } | null, last?: { __typename?: 'CustomerRetailPriceRecord', customerItemId: string, price?: number | null, currency?: string | null, effectiveFrom?: Types.TDateISO | null, effectiveUntil?: Types.TDateISO | null, fromDate?: string | null, throughDate?: string | null } | null, promo?: { __typename?: 'CustomerRetailPriceRecord', customerItemId: string, price?: number | null, currency?: string | null, effectiveFrom?: Types.TDateISO | null, effectiveUntil?: Types.TDateISO | null, fromDate?: string | null, throughDate?: string | null } | null, afterPromo?: { __typename?: 'CustomerRetailPriceRecord', customerItemId: string, price?: number | null, currency?: string | null, effectiveFrom?: Types.TDateISO | null, effectiveUntil?: Types.TDateISO | null, fromDate?: string | null, throughDate?: string | null } | null, scheduledStanding?: { __typename?: 'CustomerRetailPriceRecord', customerItemId: string, price?: number | null, currency?: string | null, effectiveFrom?: Types.TDateISO | null, effectiveUntil?: Types.TDateISO | null, fromDate?: string | null, throughDate?: string | null } | null };

export type PortalReadyDateBucketFieldsFragment = { __typename?: 'PortalReadyDateBucket', readyDate?: string | null, readyWeek?: number | null, readyWeekLabel?: string | null, readyWeekIndex?: number | null, availableQuantity: number, cumulativeAvailableQuantity: number };

export type PortalItemSummaryFragment = { __typename?: 'ItemSummaryDocument', id: string, itemId: string, name: string, description: string, sku: string, upc: string, group: string, retailPrice?: number | null, sellPrice?: number | null, imageUrl?: string | null, categories?: Array<string> | null, sortCategory?: string | null, availableQuantity?: number | null, availableNowQuantity?: number | null, readyDate?: string | null, readyWeek?: number | null, weightLbs?: number | null, lengthInches?: number | null, widthInches?: number | null, heightInches?: number | null, absorbedItemIds: Array<string>, absorbedSkus: Array<string>, portalPhotos?: Array<{ __typename?: 'PortalItemPhoto', photoUrl: string }> | null, availabilityByReadyDate?: Array<{ __typename?: 'PortalReadyDateBucket', readyDate?: string | null, readyWeek?: number | null, readyWeekLabel?: string | null, readyWeekIndex?: number | null, availableQuantity: number, cumulativeAvailableQuantity: number }> | null, sizes?: Array<{ __typename?: 'ItemDocumentSize', code: string, eaches: number, uom: number }> | null, lastOrdered?: { __typename?: 'ItemLastOrderedData', orderDate: Types.TDateISO, unitPrice: number } | null, customerEffectiveShippingUom?: { __typename?: 'CustomerEffectiveShippingUomData', code: string, eachesPerUnit?: number | null, label: string } | null, customerRetailPrice?: { __typename?: 'CustomerRetailPrice', itemId: string, baselineToken: string, current?: { __typename?: 'CustomerRetailPriceRecord', customerItemId: string, price?: number | null, currency?: string | null, effectiveFrom?: Types.TDateISO | null, effectiveUntil?: Types.TDateISO | null, fromDate?: string | null, throughDate?: string | null } | null, last?: { __typename?: 'CustomerRetailPriceRecord', customerItemId: string, price?: number | null, currency?: string | null, effectiveFrom?: Types.TDateISO | null, effectiveUntil?: Types.TDateISO | null, fromDate?: string | null, throughDate?: string | null } | null, promo?: { __typename?: 'CustomerRetailPriceRecord', customerItemId: string, price?: number | null, currency?: string | null, effectiveFrom?: Types.TDateISO | null, effectiveUntil?: Types.TDateISO | null, fromDate?: string | null, throughDate?: string | null } | null, afterPromo?: { __typename?: 'CustomerRetailPriceRecord', customerItemId: string, price?: number | null, currency?: string | null, effectiveFrom?: Types.TDateISO | null, effectiveUntil?: Types.TDateISO | null, fromDate?: string | null, throughDate?: string | null } | null, scheduledStanding?: { __typename?: 'CustomerRetailPriceRecord', customerItemId: string, price?: number | null, currency?: string | null, effectiveFrom?: Types.TDateISO | null, effectiveUntil?: Types.TDateISO | null, fromDate?: string | null, throughDate?: string | null } | null } | null };

export type GetPortalItemsQueryVariables = Types.Exact<{
  tenantId: Types.Scalars['String']['input'];
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  where?: Types.InputMaybe<Types.ItemSummaryDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.ItemSummaryDocumentSortInput> | Types.ItemSummaryDocumentSortInput>;
}>;


export type GetPortalItemsQuery = { __typename?: 'Query', customerPortalItems?: { __typename?: 'CustomerPortalItemsConnection', totalCount: number, nodes?: Array<{ __typename?: 'ItemSummaryDocument', id: string, itemId: string, name: string, description: string, sku: string, upc: string, group: string, retailPrice?: number | null, sellPrice?: number | null, imageUrl?: string | null, categories?: Array<string> | null, sortCategory?: string | null, availableQuantity?: number | null, availableNowQuantity?: number | null, readyDate?: string | null, readyWeek?: number | null, weightLbs?: number | null, lengthInches?: number | null, widthInches?: number | null, heightInches?: number | null, absorbedItemIds: Array<string>, absorbedSkus: Array<string>, portalPhotos?: Array<{ __typename?: 'PortalItemPhoto', photoUrl: string }> | null, availabilityByReadyDate?: Array<{ __typename?: 'PortalReadyDateBucket', readyDate?: string | null, readyWeek?: number | null, readyWeekLabel?: string | null, readyWeekIndex?: number | null, availableQuantity: number, cumulativeAvailableQuantity: number }> | null, sizes?: Array<{ __typename?: 'ItemDocumentSize', code: string, eaches: number, uom: number }> | null, lastOrdered?: { __typename?: 'ItemLastOrderedData', orderDate: Types.TDateISO, unitPrice: number } | null, customerEffectiveShippingUom?: { __typename?: 'CustomerEffectiveShippingUomData', code: string, eachesPerUnit?: number | null, label: string } | null, customerRetailPrice?: { __typename?: 'CustomerRetailPrice', itemId: string, baselineToken: string, current?: { __typename?: 'CustomerRetailPriceRecord', customerItemId: string, price?: number | null, currency?: string | null, effectiveFrom?: Types.TDateISO | null, effectiveUntil?: Types.TDateISO | null, fromDate?: string | null, throughDate?: string | null } | null, last?: { __typename?: 'CustomerRetailPriceRecord', customerItemId: string, price?: number | null, currency?: string | null, effectiveFrom?: Types.TDateISO | null, effectiveUntil?: Types.TDateISO | null, fromDate?: string | null, throughDate?: string | null } | null, promo?: { __typename?: 'CustomerRetailPriceRecord', customerItemId: string, price?: number | null, currency?: string | null, effectiveFrom?: Types.TDateISO | null, effectiveUntil?: Types.TDateISO | null, fromDate?: string | null, throughDate?: string | null } | null, afterPromo?: { __typename?: 'CustomerRetailPriceRecord', customerItemId: string, price?: number | null, currency?: string | null, effectiveFrom?: Types.TDateISO | null, effectiveUntil?: Types.TDateISO | null, fromDate?: string | null, throughDate?: string | null } | null, scheduledStanding?: { __typename?: 'CustomerRetailPriceRecord', customerItemId: string, price?: number | null, currency?: string | null, effectiveFrom?: Types.TDateISO | null, effectiveUntil?: Types.TDateISO | null, fromDate?: string | null, throughDate?: string | null } | null } | null }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type PortalItemChargesFragment = { __typename?: 'ItemSummaryDocument', defaultCharges: Array<{ __typename?: 'PortalItemCharge', name: string, pricing: { __typename?: 'ItemUpgradePricing', mode: Types.PricingMode, flatPrice?: number | null, markupPercent?: number | null } }>, priceLabel?: { __typename?: 'PortalItemPriceLabel', name: string, flatPrice: number } | null };

export type GetPortalItemsByIdsQueryVariables = Types.Exact<{
  tenantId: Types.Scalars['String']['input'];
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  where?: Types.InputMaybe<Types.ItemSummaryDocumentFilterInput>;
}>;


export type GetPortalItemsByIdsQuery = { __typename?: 'Query', customerPortalItems?: { __typename?: 'CustomerPortalItemsConnection', nodes?: Array<{ __typename?: 'ItemSummaryDocument', id: string, itemId: string, name: string, description: string, sku: string, upc: string, group: string, retailPrice?: number | null, sellPrice?: number | null, imageUrl?: string | null, categories?: Array<string> | null, sortCategory?: string | null, availableQuantity?: number | null, availableNowQuantity?: number | null, readyDate?: string | null, readyWeek?: number | null, weightLbs?: number | null, lengthInches?: number | null, widthInches?: number | null, heightInches?: number | null, absorbedItemIds: Array<string>, absorbedSkus: Array<string>, portalPhotos?: Array<{ __typename?: 'PortalItemPhoto', photoUrl: string }> | null, availabilityByReadyDate?: Array<{ __typename?: 'PortalReadyDateBucket', readyDate?: string | null, readyWeek?: number | null, readyWeekLabel?: string | null, readyWeekIndex?: number | null, availableQuantity: number, cumulativeAvailableQuantity: number }> | null, sizes?: Array<{ __typename?: 'ItemDocumentSize', code: string, eaches: number, uom: number }> | null, lastOrdered?: { __typename?: 'ItemLastOrderedData', orderDate: Types.TDateISO, unitPrice: number } | null, customerEffectiveShippingUom?: { __typename?: 'CustomerEffectiveShippingUomData', code: string, eachesPerUnit?: number | null, label: string } | null, customerRetailPrice?: { __typename?: 'CustomerRetailPrice', itemId: string, baselineToken: string, current?: { __typename?: 'CustomerRetailPriceRecord', customerItemId: string, price?: number | null, currency?: string | null, effectiveFrom?: Types.TDateISO | null, effectiveUntil?: Types.TDateISO | null, fromDate?: string | null, throughDate?: string | null } | null, last?: { __typename?: 'CustomerRetailPriceRecord', customerItemId: string, price?: number | null, currency?: string | null, effectiveFrom?: Types.TDateISO | null, effectiveUntil?: Types.TDateISO | null, fromDate?: string | null, throughDate?: string | null } | null, promo?: { __typename?: 'CustomerRetailPriceRecord', customerItemId: string, price?: number | null, currency?: string | null, effectiveFrom?: Types.TDateISO | null, effectiveUntil?: Types.TDateISO | null, fromDate?: string | null, throughDate?: string | null } | null, afterPromo?: { __typename?: 'CustomerRetailPriceRecord', customerItemId: string, price?: number | null, currency?: string | null, effectiveFrom?: Types.TDateISO | null, effectiveUntil?: Types.TDateISO | null, fromDate?: string | null, throughDate?: string | null } | null, scheduledStanding?: { __typename?: 'CustomerRetailPriceRecord', customerItemId: string, price?: number | null, currency?: string | null, effectiveFrom?: Types.TDateISO | null, effectiveUntil?: Types.TDateISO | null, fromDate?: string | null, throughDate?: string | null } | null } | null, defaultCharges: Array<{ __typename?: 'PortalItemCharge', name: string, pricing: { __typename?: 'ItemUpgradePricing', mode: Types.PricingMode, flatPrice?: number | null, markupPercent?: number | null } }>, priceLabel?: { __typename?: 'PortalItemPriceLabel', name: string, flatPrice: number } | null }> | null } | null };

export type PortalCartLineShippingUomFragment = { __typename?: 'ItemSummaryDocument', itemId: string, customerEffectiveShippingUom?: { __typename?: 'CustomerEffectiveShippingUomData', code: string, containerCode?: string | null, eachesPerUnit?: number | null, shipMinimum?: number | null, shipIncrement?: number | null } | null };

export type GetPortalCartLineShippingUomsQueryVariables = Types.Exact<{
  tenantId: Types.Scalars['String']['input'];
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  where?: Types.InputMaybe<Types.ItemSummaryDocumentFilterInput>;
}>;


export type GetPortalCartLineShippingUomsQuery = { __typename?: 'Query', customerPortalItems?: { __typename?: 'CustomerPortalItemsConnection', nodes?: Array<{ __typename?: 'ItemSummaryDocument', itemId: string, customerEffectiveShippingUom?: { __typename?: 'CustomerEffectiveShippingUomData', code: string, containerCode?: string | null, eachesPerUnit?: number | null, shipMinimum?: number | null, shipIncrement?: number | null } | null }> | null } | null };

export type GetPortalItemPriceQueryVariables = Types.Exact<{
  itemId: Types.Scalars['String']['input'];
  locationId: Types.Scalars['UUID']['input'];
  orderDate?: Types.InputMaybe<Types.Scalars['DateTime']['input']>;
  quantity?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type GetPortalItemPriceQuery = { __typename?: 'Query', itemPrice: number };

export type GetPortalItemPricesQueryVariables = Types.Exact<{
  itemIds: Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input'];
  locationId?: Types.InputMaybe<Types.Scalars['UUID']['input']>;
  orderDate?: Types.InputMaybe<Types.Scalars['DateTime']['input']>;
  quantity?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type GetPortalItemPricesQuery = { __typename?: 'Query', itemPrices: { __typename?: 'ItemPricesPayload', itemPrices?: Array<{ __typename?: 'ItemPriceData', itemId: string, price: number }> | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type GetPortalPriceGroupQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.PriceGroupDocumentFilterInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type GetPortalPriceGroupQuery = { __typename?: 'Query', priceGroups?: { __typename?: 'PriceGroupsConnection', nodes?: Array<{ __typename?: 'PriceGroupDocument', id: string, priceId: string, name: string, isDefault: boolean }> | null } | null };

export type GetPortalPriceLevelsQueryVariables = Types.Exact<{
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  where?: Types.InputMaybe<Types.PriceLevelDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.PriceLevelDocumentSortInput> | Types.PriceLevelDocumentSortInput>;
}>;


export type GetPortalPriceLevelsQuery = { __typename?: 'Query', priceLevels?: { __typename?: 'PriceLevelsConnection', totalCount: number, nodes?: Array<{ __typename?: 'PriceLevelDocument', id: string, priceGroupId: string, targetId: string, targetName: string, quantityThreshold: number, customerSellPrice?: number | null, growerSellPrice: number, startDate: Types.TDateISO, endDate?: Types.TDateISO | null, type: Types.TargetType, volumePoolId?: string | null }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetPortalItemAvailabilityQueryVariables = Types.Exact<{
  tenantId: Types.Scalars['String']['input'];
  where?: Types.InputMaybe<Types.ItemAvailabilityDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.ItemAvailabilityDocumentSortInput> | Types.ItemAvailabilityDocumentSortInput>;
}>;


export type GetPortalItemAvailabilityQuery = { __typename?: 'Query', customerPortalItemAvailability?: Array<{ __typename?: 'ItemAvailabilityDocument', id: string, tenantId: string, itemId: string, sku: string, upc: string, itemName: string, recordedAt: Types.TDateISO, quantity: number }> | null };

export type GetPortalItemGradeAvailabilityQueryVariables = Types.Exact<{
  tenantId: Types.Scalars['String']['input'];
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetPortalItemGradeAvailabilityQuery = { __typename?: 'Query', customerPortalItemGradeAvailability?: { __typename?: 'CustomerPortalItemGradeAvailabilityConnection', totalCount: number, nodes?: Array<{ __typename?: 'PortalItemGradeAvailabilityData', itemId: string, grades: Array<{ __typename?: 'PortalGradeAvailabilityData', grade: number, availableQuantity: number }> }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type FavoritesListFieldsFragment = { __typename?: 'FavoritesListDocument', id: string, favoritesListId: string, tenantId: string, name: string, description: string, scope: number, scopeId: string, createdBy: string, createdDate: Types.TDateISO, lastModified: Types.TDateISO, status: number, items: Array<{ __typename?: 'FavoritesListItemDocument', id: string, itemId: string, quantity: number, sortOrder: number }> };

export type GetPortalFavoritesListsQueryVariables = Types.Exact<{
  tenantId: Types.Scalars['String']['input'];
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  where?: Types.InputMaybe<Types.FavoritesListDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.FavoritesListDocumentSortInput> | Types.FavoritesListDocumentSortInput>;
}>;


export type GetPortalFavoritesListsQuery = { __typename?: 'Query', customerPortalFavoritesLists?: { __typename?: 'CustomerPortalFavoritesListsConnection', totalCount: number, nodes?: Array<{ __typename?: 'FavoritesListDocument', id: string, favoritesListId: string, tenantId: string, name: string, description: string, scope: number, scopeId: string, createdBy: string, createdDate: Types.TDateISO, lastModified: Types.TDateISO, status: number, items: Array<{ __typename?: 'FavoritesListItemDocument', id: string, itemId: string, quantity: number, sortOrder: number }> }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetPortalFavoritesListQueryVariables = Types.Exact<{
  tenantId: Types.Scalars['String']['input'];
  favoritesListId: Types.Scalars['String']['input'];
}>;


export type GetPortalFavoritesListQuery = { __typename?: 'Query', customerPortalFavoritesList?: { __typename?: 'FavoritesListDocument', id: string, favoritesListId: string, tenantId: string, name: string, description: string, scope: number, scopeId: string, createdBy: string, createdDate: Types.TDateISO, lastModified: Types.TDateISO, status: number, items: Array<{ __typename?: 'FavoritesListItemDocument', id: string, itemId: string, quantity: number, sortOrder: number }> } | null };

export type GetPortalCartQueryVariables = Types.Exact<{
  tenantId: Types.Scalars['String']['input'];
  cartId: Types.Scalars['String']['input'];
}>;


export type GetPortalCartQuery = { __typename?: 'Query', customerPortalShoppingCart?: { __typename?: 'ShoppingCartStateData', cartId: string, tenantId: string, shopperId: string, createdAt: Types.TDateISO, expectedDeliveryDate: Types.TDateISO, status: Types.ShoppingCartStatus, customer: { __typename?: 'ShoppingCartCustomerData', customerId: string, name: string }, items: Array<{ __typename?: 'ShoppingCartItemData', id: string, itemId: string, sku: string, upc: string, itemGroup: string, quantity: number, price: number, name: string, dateAdded: Types.TDateISO }> } | null };

export type GetPortalCustomerOrdersQueryVariables = Types.Exact<{
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  where?: Types.InputMaybe<Types.OrdersDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.OrdersDocumentSortInput> | Types.OrdersDocumentSortInput>;
}>;


export type GetPortalCustomerOrdersQuery = { __typename?: 'Query', orders?: { __typename?: 'OrdersConnection', totalCount: number, nodes?: Array<{ __typename?: 'OrdersDocument', id: string, orderId: string, orderNumber: string, poNumber: string, customerId: string, orderStatus: Types.OrderStatus, orderType: Types.OrderType, initializedDate: Types.TDateISO, expectedDeliveryDate: Types.TDateISO, numberOfLines: number, noTaxReason?: Types.CustomerTaxExemptionReason | null, orderTotal: { __typename?: 'MoneyData', amount: number, currency: string }, flatCharges: Array<{ __typename?: 'OrderFlatChargeDocument', id: string, name: string, amount: number }>, estimatedTax?: { __typename?: 'OrderTaxEstimatePayload', amount: number, estimatedAt?: Types.TDateISO | null, status: Types.OrderTaxEstimateStatus, breakdown: Array<{ __typename?: 'OrderTaxEstimateJurisdictionPayload', jurisdiction: string, level: string, state?: string | null, rate: number, amount: number, taxableAmount: number, reason: string }> } | null, locations: { __typename?: 'OrderLocationDocumentData', id: string, code: string, storeNumber: string }, orderNotes: Array<{ __typename?: 'OrderContextNoteDocument', context: Types.NoteContext, text: string }> }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetPortalCustomerOrderLinesQueryVariables = Types.Exact<{
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  where?: Types.InputMaybe<Types.OrderLineItemDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.OrderLineItemDocumentSortInput> | Types.OrderLineItemDocumentSortInput>;
}>;


export type GetPortalCustomerOrderLinesQuery = { __typename?: 'Query', orderLineItems?: { __typename?: 'OrderLineItemsConnection', totalCount: number, nodes?: Array<{ __typename?: 'OrderLineItemDocument', id: string, orderId: string, itemId: string, lineNumber: number, sku: string, name: string, quantity?: number | null, orderedQuantity?: number | null, acknowledgedQuantity?: number | null, shippedQuantity?: number | null, orderedUnits?: number | null, eachesPerUnit?: number | null, shippingUomLabel?: string | null, orderEntryUnit: Types.OrderEntryUnit, eachesQuantity?: number | null, handlingUom?: number | null, acknowledgedZeroBillsNothing: boolean, shippedZeroBillsNothing: boolean, orderedEaches?: number | null, allocatedUnits?: number | null, allocatedEaches?: number | null, acknowledgedUnits?: number | null, acknowledgedEaches?: number | null, shippedUnits?: number | null, shippedEaches?: number | null, upgradeSubtotalAdjustment: number, price: number, overridePrice?: number | null, currency: string, upgrades: Array<{ __typename?: 'OrderLineUpgradeDocument', name: string, pricing: { __typename?: 'ItemUpgradePricing', mode: Types.PricingMode, flatPrice?: number | null, markupPercent?: number | null } }> }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type PortalDeliveryDateRejectionFragment = { __typename?: 'PortalDeliveryDateRejectionData', requestedDate: string, reason: Types.DeliveryDateIneligibleReason, allowedDays: Array<Types.DayOfWeek>, earliestEligibleDate?: string | null };

export type PortalCustomDomainFieldsFragment = { __typename?: 'PortalCustomDomainData', domain: string, status: Types.PortalCustomDomainStatus, verificationRecordHost: string, verificationRecordValue: string, verifiedAt?: Types.TDateISO | null, isPrimary: boolean };

export type PortalHelpContactFieldsFragment = { __typename?: 'PortalHelpContactData', name: string, email: string };

export type PortalOrderContactFieldsFragment = { __typename?: 'PortalOrderContactData', name?: string | null, phone: string };

export type PortalDeliveryBlackoutFieldsFragment = { __typename?: 'PortalDeliveryBlackoutData', startDate: string, endDate: string };

export type PortalSettingsFieldsFragment = { __typename?: 'PortalSettingsStateData', tenantId: string, hasSavedSettings: boolean, portalEnabled: boolean, minimumOrderAmount: number, selfRegistrationEnabled: boolean, buyerContactEditingEnabled: boolean, buyerRetailPriceEditingEnabled: boolean, catalogDisplayMode: Types.CatalogDisplayMode, catalogChipSource: Types.CatalogChipSource, availabilityMinGrade: number, availabilityLocationId?: string | null, includeSellableHardGoods: boolean, companySlug: string, preferAvailabilityImage: boolean, orderCutoffTime?: string | null, orderCutoffTimeZoneId?: string | null, orderCutoffLeadDays: number, showGradeOnPortal: boolean, portalMaxDaysOut: number, availabilityReportId?: string | null, prePricingEnabled: boolean, portalAutoAcknowledge: boolean, portalAutoAllocate: boolean, portalAutoAllocateStrategy: Types.PortalAutoAllocateStrategy, portalCheckoutOrderStatus: Types.PortalCheckoutOrderStatus, primaryCustomDomain?: string | null, checkoutMethod: Types.PortalCheckoutMethod, priceLabels: Array<{ __typename?: 'PortalPriceLabel', priceLabelId: string, name: string, flatPrice: number, isDefault: boolean }>, deliveryBlackouts: Array<{ __typename?: 'PortalDeliveryBlackoutData', startDate: string, endDate: string }>, customDomains: Array<{ __typename?: 'PortalCustomDomainData', domain: string, status: Types.PortalCustomDomainStatus, verificationRecordHost: string, verificationRecordValue: string, verifiedAt?: Types.TDateISO | null, isPrimary: boolean }>, helpContact?: { __typename?: 'PortalHelpContactData', name: string, email: string } | null, orderContact?: { __typename?: 'PortalOrderContactData', name?: string | null, phone: string } | null };

export type GetPortalSettingsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetPortalSettingsQuery = { __typename?: 'Query', portalSettings?: { __typename?: 'PortalSettingsStateData', availabilityLocationIds: Array<string>, tenantId: string, hasSavedSettings: boolean, portalEnabled: boolean, minimumOrderAmount: number, selfRegistrationEnabled: boolean, buyerContactEditingEnabled: boolean, buyerRetailPriceEditingEnabled: boolean, catalogDisplayMode: Types.CatalogDisplayMode, catalogChipSource: Types.CatalogChipSource, availabilityMinGrade: number, availabilityLocationId?: string | null, includeSellableHardGoods: boolean, companySlug: string, preferAvailabilityImage: boolean, orderCutoffTime?: string | null, orderCutoffTimeZoneId?: string | null, orderCutoffLeadDays: number, showGradeOnPortal: boolean, portalMaxDaysOut: number, availabilityReportId?: string | null, prePricingEnabled: boolean, portalAutoAcknowledge: boolean, portalAutoAllocate: boolean, portalAutoAllocateStrategy: Types.PortalAutoAllocateStrategy, portalCheckoutOrderStatus: Types.PortalCheckoutOrderStatus, primaryCustomDomain?: string | null, checkoutMethod: Types.PortalCheckoutMethod, priceLabels: Array<{ __typename?: 'PortalPriceLabel', priceLabelId: string, name: string, flatPrice: number, isDefault: boolean }>, deliveryBlackouts: Array<{ __typename?: 'PortalDeliveryBlackoutData', startDate: string, endDate: string }>, customDomains: Array<{ __typename?: 'PortalCustomDomainData', domain: string, status: Types.PortalCustomDomainStatus, verificationRecordHost: string, verificationRecordValue: string, verifiedAt?: Types.TDateISO | null, isPrimary: boolean }>, helpContact?: { __typename?: 'PortalHelpContactData', name: string, email: string } | null, orderContact?: { __typename?: 'PortalOrderContactData', name?: string | null, phone: string } | null } | null };

export type TenantByCompanySlugQueryVariables = Types.Exact<{
  slug: Types.Scalars['String']['input'];
}>;


export type TenantByCompanySlugQuery = { __typename?: 'Query', tenantByCompanySlug?: { __typename?: 'TenantByCompanySlugView', companySlug: string, tenantId: string } | null };

export type TenantByPortalHostQueryVariables = Types.Exact<{
  host: Types.Scalars['String']['input'];
}>;


export type TenantByPortalHostQuery = { __typename?: 'Query', tenantByPortalHost?: { __typename?: 'PortalHostTenantView', tenantId: string, host: string, companySlug: string, isCustomDomain: boolean } | null };

export type PortalPublicBrandingFieldsFragment = { __typename?: 'PortalPublicBranding', displayName: string, tagline: string, logoUrl: string, primaryColorHex: string, signInPanel?: { __typename?: 'PortalPublicSignInPanel', body: string, headline: string, imageUrl: string, linkLabel: string, linkUrl: string } | null };

export type GetPortalBrandingBySlugQueryVariables = Types.Exact<{
  slug: Types.Scalars['String']['input'];
}>;


export type GetPortalBrandingBySlugQuery = { __typename?: 'Query', portalBrandingBySlug?: { __typename?: 'PortalPublicBranding', displayName: string, tagline: string, logoUrl: string, primaryColorHex: string, signInPanel?: { __typename?: 'PortalPublicSignInPanel', body: string, headline: string, imageUrl: string, linkLabel: string, linkUrl: string } | null } | null };

export type GetPortalBrandingByHostQueryVariables = Types.Exact<{
  host: Types.Scalars['String']['input'];
}>;


export type GetPortalBrandingByHostQuery = { __typename?: 'Query', portalBrandingByHost?: { __typename?: 'PortalPublicBranding', displayName: string, tagline: string, logoUrl: string, primaryColorHex: string, signInPanel?: { __typename?: 'PortalPublicSignInPanel', body: string, headline: string, imageUrl: string, linkLabel: string, linkUrl: string } | null } | null };

export type GetCustomerPortalSettingsQueryVariables = Types.Exact<{
  tenantId: Types.Scalars['String']['input'];
}>;


export type GetCustomerPortalSettingsQuery = { __typename?: 'Query', customerPortalSettings?: { __typename?: 'CustomerPortalSettingsData', portalEnabled: boolean, minimumOrderAmount: number, catalogDisplayMode: Types.CatalogDisplayMode, catalogChipSource: Types.CatalogChipSource, availabilityMinGrade: number, availabilityLocationId?: string | null, availabilityLocationIds: Array<string>, includeSellableHardGoods: boolean, showGradeOnPortal: boolean, prePricingEnabled: boolean, buyerContactEditingEnabled: boolean, buyerRetailPriceEditingEnabled: boolean, checkoutMethod: Types.PortalCheckoutMethod, orderContact?: { __typename?: 'PortalOrderContactData', name?: string | null, phone: string } | null, helpContact?: { __typename?: 'PortalHelpContactData', name: string, email: string } | null, gradeLabels: Array<{ __typename?: 'TenantGradeLabelData', grade: number, label: string }> } | null };

export type PortalAccountFieldsFragment = { __typename?: 'CustomerPortalAccountData', customerId: string, name: string, erpId: string, termsId: string, priceGroupId: string, effectiveOrderEntryUnit: Types.OrderEntryUnit, effectivePriceEntryUnit: Types.PriceEntryUnit, shipFromLocations: Array<{ __typename?: 'ShipFromLocationData', name: string }>, orderSubmitter?: { __typename?: 'OrderSubmitterData', name?: string | null, phone?: string | null, email?: string | null } | null, billingAddresses: Array<{ __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }>, locations: Array<{ __typename?: 'CustomerPortalLocationData', id: string, code: string, name: string, address: { __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }> }>, contacts: Array<{ __typename?: 'CustomerPortalContactData', id: string, type: Types.ContactType, firstName: string, lastName: string, title: string, phoneNumbers: Array<{ __typename?: 'PhoneNumberData', type: Types.PhoneNumberType, value: string }>, emailAddresses: Array<{ __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string }> }>, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }> };

export type GetPortalAccountQueryVariables = Types.Exact<{
  tenantId: Types.Scalars['String']['input'];
}>;


export type GetPortalAccountQuery = { __typename?: 'Query', customerPortalAccount?: { __typename?: 'CustomerPortalAccountData', customerId: string, name: string, erpId: string, termsId: string, priceGroupId: string, effectiveOrderEntryUnit: Types.OrderEntryUnit, effectivePriceEntryUnit: Types.PriceEntryUnit, shipFromLocations: Array<{ __typename?: 'ShipFromLocationData', name: string }>, orderSubmitter?: { __typename?: 'OrderSubmitterData', name?: string | null, phone?: string | null, email?: string | null } | null, billingAddresses: Array<{ __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }>, locations: Array<{ __typename?: 'CustomerPortalLocationData', id: string, code: string, name: string, address: { __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }> }>, contacts: Array<{ __typename?: 'CustomerPortalContactData', id: string, type: Types.ContactType, firstName: string, lastName: string, title: string, phoneNumbers: Array<{ __typename?: 'PhoneNumberData', type: Types.PhoneNumberType, value: string }>, emailAddresses: Array<{ __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string }> }>, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }> } | null };

export type PortalSellableHardgoodFragment = { __typename?: 'MaterialItemDocument', id: string, erpId: string, name: string, description: string, itemType?: string | null, category: string, isOrganic: boolean, availableQuantity?: number | null, availableNowQuantity?: number | null, readyDate?: string | null, readyWeek?: number | null, availabilityByReadyDate?: Array<{ __typename?: 'PortalReadyDateBucket', readyDate?: string | null, readyWeek?: number | null, readyWeekLabel?: string | null, readyWeekIndex?: number | null, availableQuantity: number, cumulativeAvailableQuantity: number }> | null, materialImage?: { __typename?: 'MaterialImageData', imageUrl?: string | null } | null };

export type GetCustomerPortalSellableHardgoodsQueryVariables = Types.Exact<{
  tenantId: Types.Scalars['String']['input'];
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  where?: Types.InputMaybe<Types.MaterialItemDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.MaterialItemDocumentSortInput> | Types.MaterialItemDocumentSortInput>;
}>;


export type GetCustomerPortalSellableHardgoodsQuery = { __typename?: 'Query', customerPortalSellableHardgoods?: { __typename?: 'CustomerPortalSellableHardgoodsConnection', totalCount: number, nodes?: Array<{ __typename?: 'MaterialItemDocument', id: string, erpId: string, name: string, description: string, itemType?: string | null, category: string, isOrganic: boolean, availableQuantity?: number | null, availableNowQuantity?: number | null, readyDate?: string | null, readyWeek?: number | null, availabilityByReadyDate?: Array<{ __typename?: 'PortalReadyDateBucket', readyDate?: string | null, readyWeek?: number | null, readyWeekLabel?: string | null, readyWeekIndex?: number | null, availableQuantity: number, cumulativeAvailableQuantity: number }> | null, materialImage?: { __typename?: 'MaterialImageData', imageUrl?: string | null } | null }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetCustomerPortalEligibleDeliveryDatesQueryVariables = Types.Exact<{
  tenantId: Types.Scalars['String']['input'];
  locationId?: Types.InputMaybe<Types.Scalars['UUID']['input']>;
  isPreorder?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type GetCustomerPortalEligibleDeliveryDatesQuery = { __typename?: 'Query', customerPortalEligibleDeliveryDates?: { __typename?: 'EligibleDeliveryDatesData', restrictionActive: boolean, enforcedAtCheckout: boolean, earliestEligibleDate?: string | null, dates: Array<{ __typename?: 'EligibleDeliveryDateData', date: string, isEligible: boolean, ineligibleReason?: Types.DeliveryDateIneligibleReason | null }> } | null };

export type GetPortalCartFreightQueryVariables = Types.Exact<{
  locationId: Types.Scalars['UUID']['input'];
  subtotal: Types.Scalars['Decimal']['input'];
}>;


export type GetPortalCartFreightQuery = { __typename?: 'Query', customerPortalCartFreight?: { __typename?: 'PortalCartFreightData', amount: number, type: Types.FreightChargeType, value: number } | null };

export const PortalReadyDateBucketFieldsFragmentDoc = new TypedDocumentString(`
    fragment PortalReadyDateBucketFields on PortalReadyDateBucket {
  readyDate
  readyWeek
  readyWeekLabel
  readyWeekIndex
  availableQuantity
  cumulativeAvailableQuantity
}
    `, {"fragmentName":"PortalReadyDateBucketFields"});
export const CustomerRetailPriceRecordFieldsFragmentDoc = new TypedDocumentString(`
    fragment CustomerRetailPriceRecordFields on CustomerRetailPriceRecord {
  customerItemId
  price
  currency
  effectiveFrom
  effectiveUntil
  fromDate
  throughDate
}
    `, {"fragmentName":"CustomerRetailPriceRecordFields"});
export const CustomerRetailPriceFieldsFragmentDoc = new TypedDocumentString(`
    fragment CustomerRetailPriceFields on CustomerRetailPrice {
  itemId
  current {
    ...CustomerRetailPriceRecordFields
  }
  last {
    ...CustomerRetailPriceRecordFields
  }
  promo {
    ...CustomerRetailPriceRecordFields
  }
  afterPromo {
    ...CustomerRetailPriceRecordFields
  }
  scheduledStanding {
    ...CustomerRetailPriceRecordFields
  }
  baselineToken
}
    fragment CustomerRetailPriceRecordFields on CustomerRetailPriceRecord {
  customerItemId
  price
  currency
  effectiveFrom
  effectiveUntil
  fromDate
  throughDate
}`, {"fragmentName":"CustomerRetailPriceFields"});
export const PortalItemSummaryFragmentDoc = new TypedDocumentString(`
    fragment PortalItemSummary on ItemSummaryDocument {
  id
  itemId
  name
  description
  sku
  upc
  group
  retailPrice
  sellPrice
  imageUrl
  portalPhotos {
    photoUrl
  }
  categories
  sortCategory
  availableQuantity
  availableNowQuantity
  availabilityByReadyDate {
    ...PortalReadyDateBucketFields
  }
  readyDate
  readyWeek
  weightLbs
  lengthInches
  widthInches
  heightInches
  sizes {
    code
    eaches
    uom
  }
  lastOrdered {
    orderDate
    unitPrice
  }
  customerEffectiveShippingUom {
    code
    eachesPerUnit
    label
  }
  customerRetailPrice {
    ...CustomerRetailPriceFields
  }
  absorbedItemIds
  absorbedSkus
}
    fragment CustomerRetailPriceRecordFields on CustomerRetailPriceRecord {
  customerItemId
  price
  currency
  effectiveFrom
  effectiveUntil
  fromDate
  throughDate
}
fragment CustomerRetailPriceFields on CustomerRetailPrice {
  itemId
  current {
    ...CustomerRetailPriceRecordFields
  }
  last {
    ...CustomerRetailPriceRecordFields
  }
  promo {
    ...CustomerRetailPriceRecordFields
  }
  afterPromo {
    ...CustomerRetailPriceRecordFields
  }
  scheduledStanding {
    ...CustomerRetailPriceRecordFields
  }
  baselineToken
}
fragment PortalReadyDateBucketFields on PortalReadyDateBucket {
  readyDate
  readyWeek
  readyWeekLabel
  readyWeekIndex
  availableQuantity
  cumulativeAvailableQuantity
}`, {"fragmentName":"PortalItemSummary"});
export const PortalItemChargesFragmentDoc = new TypedDocumentString(`
    fragment PortalItemCharges on ItemSummaryDocument {
  defaultCharges {
    name
    pricing {
      mode
      flatPrice
      markupPercent
    }
  }
  priceLabel {
    name
    flatPrice
  }
}
    `, {"fragmentName":"PortalItemCharges"});
export const PortalCartLineShippingUomFragmentDoc = new TypedDocumentString(`
    fragment PortalCartLineShippingUom on ItemSummaryDocument {
  itemId
  customerEffectiveShippingUom {
    code
    containerCode
    eachesPerUnit
    shipMinimum
    shipIncrement
  }
}
    `, {"fragmentName":"PortalCartLineShippingUom"});
export const FavoritesListFieldsFragmentDoc = new TypedDocumentString(`
    fragment FavoritesListFields on FavoritesListDocument {
  id
  favoritesListId
  tenantId
  name
  description
  scope
  scopeId
  items {
    id
    itemId
    quantity
    sortOrder
  }
  createdBy
  createdDate
  lastModified
  status
}
    `, {"fragmentName":"FavoritesListFields"});
export const PortalDeliveryDateRejectionFragmentDoc = new TypedDocumentString(`
    fragment PortalDeliveryDateRejection on PortalDeliveryDateRejectionData {
  requestedDate
  reason
  allowedDays
  earliestEligibleDate
}
    `, {"fragmentName":"PortalDeliveryDateRejection"});
export const PortalDeliveryBlackoutFieldsFragmentDoc = new TypedDocumentString(`
    fragment PortalDeliveryBlackoutFields on PortalDeliveryBlackoutData {
  startDate
  endDate
}
    `, {"fragmentName":"PortalDeliveryBlackoutFields"});
export const PortalCustomDomainFieldsFragmentDoc = new TypedDocumentString(`
    fragment PortalCustomDomainFields on PortalCustomDomainData {
  domain
  status
  verificationRecordHost
  verificationRecordValue
  verifiedAt
  isPrimary
}
    `, {"fragmentName":"PortalCustomDomainFields"});
export const PortalHelpContactFieldsFragmentDoc = new TypedDocumentString(`
    fragment PortalHelpContactFields on PortalHelpContactData {
  name
  email
}
    `, {"fragmentName":"PortalHelpContactFields"});
export const PortalOrderContactFieldsFragmentDoc = new TypedDocumentString(`
    fragment PortalOrderContactFields on PortalOrderContactData {
  name
  phone
}
    `, {"fragmentName":"PortalOrderContactFields"});
export const PortalSettingsFieldsFragmentDoc = new TypedDocumentString(`
    fragment PortalSettingsFields on PortalSettingsStateData {
  tenantId
  hasSavedSettings
  portalEnabled
  minimumOrderAmount
  selfRegistrationEnabled
  buyerContactEditingEnabled
  buyerRetailPriceEditingEnabled
  catalogDisplayMode
  catalogChipSource
  availabilityMinGrade
  availabilityLocationId
  includeSellableHardGoods
  companySlug
  preferAvailabilityImage
  orderCutoffTime
  orderCutoffTimeZoneId
  orderCutoffLeadDays
  showGradeOnPortal
  portalMaxDaysOut
  availabilityReportId
  prePricingEnabled
  priceLabels {
    priceLabelId
    name
    flatPrice
    isDefault
  }
  portalAutoAcknowledge
  portalAutoAllocate
  portalAutoAllocateStrategy
  portalCheckoutOrderStatus
  deliveryBlackouts {
    ...PortalDeliveryBlackoutFields
  }
  customDomains {
    ...PortalCustomDomainFields
  }
  primaryCustomDomain
  helpContact {
    ...PortalHelpContactFields
  }
  checkoutMethod
  orderContact {
    ...PortalOrderContactFields
  }
}
    fragment PortalCustomDomainFields on PortalCustomDomainData {
  domain
  status
  verificationRecordHost
  verificationRecordValue
  verifiedAt
  isPrimary
}
fragment PortalHelpContactFields on PortalHelpContactData {
  name
  email
}
fragment PortalOrderContactFields on PortalOrderContactData {
  name
  phone
}
fragment PortalDeliveryBlackoutFields on PortalDeliveryBlackoutData {
  startDate
  endDate
}`, {"fragmentName":"PortalSettingsFields"});
export const PortalPublicBrandingFieldsFragmentDoc = new TypedDocumentString(`
    fragment PortalPublicBrandingFields on PortalPublicBranding {
  displayName
  tagline
  logoUrl
  primaryColorHex
  signInPanel {
    body
    headline
    imageUrl
    linkLabel
    linkUrl
  }
}
    `, {"fragmentName":"PortalPublicBrandingFields"});
export const PortalAccountFieldsFragmentDoc = new TypedDocumentString(`
    fragment PortalAccountFields on CustomerPortalAccountData {
  customerId
  name
  erpId
  termsId
  priceGroupId
  effectiveOrderEntryUnit
  effectivePriceEntryUnit
  shipFromLocations {
    name
  }
  orderSubmitter {
    ...OrderSubmitter
  }
  billingAddresses {
    ...Address
  }
  locations {
    id
    code
    name
    address {
      ...Address
    }
    salesPeople {
      ...SalesPerson
    }
  }
  contacts {
    id
    type
    firstName
    lastName
    title
    phoneNumbers {
      type
      value
    }
    emailAddresses {
      type
      value
    }
  }
  salesPeople {
    ...SalesPerson
  }
}
    fragment OrderSubmitter on OrderSubmitterData {
  name
  phone
  email
}
fragment Address on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment SalesPerson on SalesPersonData {
  emailAddress {
    type
    value
  }
}`, {"fragmentName":"PortalAccountFields"});
export const PortalSellableHardgoodFragmentDoc = new TypedDocumentString(`
    fragment PortalSellableHardgood on MaterialItemDocument {
  id
  erpId
  name
  description
  itemType
  category
  isOrganic
  availableQuantity
  availableNowQuantity
  availabilityByReadyDate {
    ...PortalReadyDateBucketFields
  }
  readyDate
  readyWeek
  materialImage {
    imageUrl
  }
}
    fragment PortalReadyDateBucketFields on PortalReadyDateBucket {
  readyDate
  readyWeek
  readyWeekLabel
  readyWeekIndex
  availableQuantity
  cumulativeAvailableQuantity
}`, {"fragmentName":"PortalSellableHardgood"});
export const GetPortalItemsDocument = new TypedDocumentString(`
    query GetPortalItems($tenantId: String!, $first: Int, $after: String, $where: ItemSummaryDocumentFilterInput, $order: [ItemSummaryDocumentSortInput!]) {
  customerPortalItems(
    tenantId: $tenantId
    first: $first
    after: $after
    where: $where
    order: $order
  ) {
    nodes {
      ...PortalItemSummary
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment CustomerRetailPriceRecordFields on CustomerRetailPriceRecord {
  customerItemId
  price
  currency
  effectiveFrom
  effectiveUntil
  fromDate
  throughDate
}
fragment CustomerRetailPriceFields on CustomerRetailPrice {
  itemId
  current {
    ...CustomerRetailPriceRecordFields
  }
  last {
    ...CustomerRetailPriceRecordFields
  }
  promo {
    ...CustomerRetailPriceRecordFields
  }
  afterPromo {
    ...CustomerRetailPriceRecordFields
  }
  scheduledStanding {
    ...CustomerRetailPriceRecordFields
  }
  baselineToken
}
fragment PortalReadyDateBucketFields on PortalReadyDateBucket {
  readyDate
  readyWeek
  readyWeekLabel
  readyWeekIndex
  availableQuantity
  cumulativeAvailableQuantity
}
fragment PortalItemSummary on ItemSummaryDocument {
  id
  itemId
  name
  description
  sku
  upc
  group
  retailPrice
  sellPrice
  imageUrl
  portalPhotos {
    photoUrl
  }
  categories
  sortCategory
  availableQuantity
  availableNowQuantity
  availabilityByReadyDate {
    ...PortalReadyDateBucketFields
  }
  readyDate
  readyWeek
  weightLbs
  lengthInches
  widthInches
  heightInches
  sizes {
    code
    eaches
    uom
  }
  lastOrdered {
    orderDate
    unitPrice
  }
  customerEffectiveShippingUom {
    code
    eachesPerUnit
    label
  }
  customerRetailPrice {
    ...CustomerRetailPriceFields
  }
  absorbedItemIds
  absorbedSkus
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetPortalItemsByIdsDocument = new TypedDocumentString(`
    query GetPortalItemsByIds($tenantId: String!, $first: Int, $where: ItemSummaryDocumentFilterInput) {
  customerPortalItems(tenantId: $tenantId, first: $first, where: $where) {
    nodes {
      ...PortalItemSummary
      ...PortalItemCharges
    }
  }
}
    fragment CustomerRetailPriceRecordFields on CustomerRetailPriceRecord {
  customerItemId
  price
  currency
  effectiveFrom
  effectiveUntil
  fromDate
  throughDate
}
fragment CustomerRetailPriceFields on CustomerRetailPrice {
  itemId
  current {
    ...CustomerRetailPriceRecordFields
  }
  last {
    ...CustomerRetailPriceRecordFields
  }
  promo {
    ...CustomerRetailPriceRecordFields
  }
  afterPromo {
    ...CustomerRetailPriceRecordFields
  }
  scheduledStanding {
    ...CustomerRetailPriceRecordFields
  }
  baselineToken
}
fragment PortalReadyDateBucketFields on PortalReadyDateBucket {
  readyDate
  readyWeek
  readyWeekLabel
  readyWeekIndex
  availableQuantity
  cumulativeAvailableQuantity
}
fragment PortalItemSummary on ItemSummaryDocument {
  id
  itemId
  name
  description
  sku
  upc
  group
  retailPrice
  sellPrice
  imageUrl
  portalPhotos {
    photoUrl
  }
  categories
  sortCategory
  availableQuantity
  availableNowQuantity
  availabilityByReadyDate {
    ...PortalReadyDateBucketFields
  }
  readyDate
  readyWeek
  weightLbs
  lengthInches
  widthInches
  heightInches
  sizes {
    code
    eaches
    uom
  }
  lastOrdered {
    orderDate
    unitPrice
  }
  customerEffectiveShippingUom {
    code
    eachesPerUnit
    label
  }
  customerRetailPrice {
    ...CustomerRetailPriceFields
  }
  absorbedItemIds
  absorbedSkus
}
fragment PortalItemCharges on ItemSummaryDocument {
  defaultCharges {
    name
    pricing {
      mode
      flatPrice
      markupPercent
    }
  }
  priceLabel {
    name
    flatPrice
  }
}`);
export const GetPortalCartLineShippingUomsDocument = new TypedDocumentString(`
    query GetPortalCartLineShippingUoms($tenantId: String!, $first: Int, $where: ItemSummaryDocumentFilterInput) {
  customerPortalItems(tenantId: $tenantId, first: $first, where: $where) {
    nodes {
      ...PortalCartLineShippingUom
    }
  }
}
    fragment PortalCartLineShippingUom on ItemSummaryDocument {
  itemId
  customerEffectiveShippingUom {
    code
    containerCode
    eachesPerUnit
    shipMinimum
    shipIncrement
  }
}`);
export const GetPortalItemPriceDocument = new TypedDocumentString(`
    query GetPortalItemPrice($itemId: String!, $locationId: UUID!, $orderDate: DateTime, $quantity: Int = 1) {
  itemPrice(
    itemId: $itemId
    locationId: $locationId
    orderDate: $orderDate
    quantity: $quantity
  )
}
    `);
export const GetPortalItemPricesDocument = new TypedDocumentString(`
    query GetPortalItemPrices($itemIds: [String!]!, $locationId: UUID, $orderDate: DateTime, $quantity: Int = 1) {
  itemPrices(
    itemIds: $itemIds
    locationId: $locationId
    orderDate: $orderDate
    quantity: $quantity
  ) {
    itemPrices {
      itemId
      price
    }
    errors {
      code
      message
    }
  }
}
    `);
export const GetPortalPriceGroupDocument = new TypedDocumentString(`
    query GetPortalPriceGroup($where: PriceGroupDocumentFilterInput, $first: Int) {
  priceGroups(where: $where, first: $first) {
    nodes {
      id
      priceId
      name
      isDefault
    }
  }
}
    `);
export const GetPortalPriceLevelsDocument = new TypedDocumentString(`
    query GetPortalPriceLevels($first: Int, $after: String, $where: PriceLevelDocumentFilterInput, $order: [PriceLevelDocumentSortInput!]) {
  priceLevels(first: $first, after: $after, where: $where, order: $order) {
    nodes {
      id
      priceGroupId
      targetId
      targetName
      quantityThreshold
      customerSellPrice
      growerSellPrice
      startDate
      endDate
      type
      volumePoolId
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetPortalItemAvailabilityDocument = new TypedDocumentString(`
    query GetPortalItemAvailability($tenantId: String!, $where: ItemAvailabilityDocumentFilterInput, $order: [ItemAvailabilityDocumentSortInput!]) {
  customerPortalItemAvailability(
    tenantId: $tenantId
    where: $where
    order: $order
  ) {
    id
    tenantId
    itemId
    sku
    upc
    itemName
    recordedAt
    quantity
  }
}
    `);
export const GetPortalItemGradeAvailabilityDocument = new TypedDocumentString(`
    query GetPortalItemGradeAvailability($tenantId: String!, $first: Int, $after: String) {
  customerPortalItemGradeAvailability(
    tenantId: $tenantId
    first: $first
    after: $after
  ) {
    nodes {
      itemId
      grades {
        grade
        availableQuantity
      }
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetPortalFavoritesListsDocument = new TypedDocumentString(`
    query GetPortalFavoritesLists($tenantId: String!, $first: Int, $after: String, $where: FavoritesListDocumentFilterInput, $order: [FavoritesListDocumentSortInput!]) {
  customerPortalFavoritesLists(
    tenantId: $tenantId
    first: $first
    after: $after
    where: $where
    order: $order
  ) {
    nodes {
      ...FavoritesListFields
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment FavoritesListFields on FavoritesListDocument {
  id
  favoritesListId
  tenantId
  name
  description
  scope
  scopeId
  items {
    id
    itemId
    quantity
    sortOrder
  }
  createdBy
  createdDate
  lastModified
  status
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetPortalFavoritesListDocument = new TypedDocumentString(`
    query GetPortalFavoritesList($tenantId: String!, $favoritesListId: String!) {
  customerPortalFavoritesList(
    tenantId: $tenantId
    favoritesListId: $favoritesListId
  ) {
    ...FavoritesListFields
  }
}
    fragment FavoritesListFields on FavoritesListDocument {
  id
  favoritesListId
  tenantId
  name
  description
  scope
  scopeId
  items {
    id
    itemId
    quantity
    sortOrder
  }
  createdBy
  createdDate
  lastModified
  status
}`);
export const GetPortalCartDocument = new TypedDocumentString(`
    query GetPortalCart($tenantId: String!, $cartId: String!) {
  customerPortalShoppingCart(tenantId: $tenantId, cartId: $cartId) {
    cartId
    tenantId
    shopperId
    createdAt
    expectedDeliveryDate
    status
    customer {
      customerId
      name
    }
    items {
      id
      itemId
      sku
      upc
      itemGroup
      quantity
      price
      name
      dateAdded
    }
  }
}
    `);
export const GetPortalCustomerOrdersDocument = new TypedDocumentString(`
    query GetPortalCustomerOrders($first: Int, $after: String, $where: OrdersDocumentFilterInput, $order: [OrdersDocumentSortInput!]) {
  orders(first: $first, after: $after, where: $where, order: $order) {
    nodes {
      id
      orderId
      orderNumber
      poNumber
      customerId
      orderStatus
      orderType
      initializedDate
      expectedDeliveryDate
      numberOfLines
      orderTotal {
        amount
        currency
      }
      flatCharges {
        id
        name
        amount
      }
      estimatedTax {
        ...OrderTaxEstimateSummary
      }
      noTaxReason
      locations {
        id
        code
        storeNumber
      }
      orderNotes {
        context
        text
      }
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}
fragment OrderTaxEstimateSummary on OrderTaxEstimatePayload {
  amount
  breakdown {
    jurisdiction
    level
    state
    rate
    amount
    taxableAmount
    reason
  }
  estimatedAt
  status
}`);
export const GetPortalCustomerOrderLinesDocument = new TypedDocumentString(`
    query GetPortalCustomerOrderLines($first: Int, $after: String, $where: OrderLineItemDocumentFilterInput, $order: [OrderLineItemDocumentSortInput!]) {
  orderLineItems(first: $first, after: $after, where: $where, order: $order) {
    nodes {
      id
      orderId
      itemId
      lineNumber
      sku
      name
      quantity
      orderedQuantity
      acknowledgedQuantity
      shippedQuantity
      orderedUnits
      eachesPerUnit
      shippingUomLabel
      orderEntryUnit
      eachesQuantity
      handlingUom
      acknowledgedZeroBillsNothing
      shippedZeroBillsNothing
      orderedEaches
      allocatedUnits
      allocatedEaches
      acknowledgedUnits
      acknowledgedEaches
      shippedUnits
      shippedEaches
      upgradeSubtotalAdjustment
      upgrades {
        name
        pricing {
          mode
          flatPrice
          markupPercent
        }
      }
      price
      overridePrice
      currency
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetPortalSettingsDocument = new TypedDocumentString(`
    query GetPortalSettings {
  portalSettings {
    ...PortalSettingsFields
    availabilityLocationIds
  }
}
    fragment PortalCustomDomainFields on PortalCustomDomainData {
  domain
  status
  verificationRecordHost
  verificationRecordValue
  verifiedAt
  isPrimary
}
fragment PortalHelpContactFields on PortalHelpContactData {
  name
  email
}
fragment PortalOrderContactFields on PortalOrderContactData {
  name
  phone
}
fragment PortalDeliveryBlackoutFields on PortalDeliveryBlackoutData {
  startDate
  endDate
}
fragment PortalSettingsFields on PortalSettingsStateData {
  tenantId
  hasSavedSettings
  portalEnabled
  minimumOrderAmount
  selfRegistrationEnabled
  buyerContactEditingEnabled
  buyerRetailPriceEditingEnabled
  catalogDisplayMode
  catalogChipSource
  availabilityMinGrade
  availabilityLocationId
  includeSellableHardGoods
  companySlug
  preferAvailabilityImage
  orderCutoffTime
  orderCutoffTimeZoneId
  orderCutoffLeadDays
  showGradeOnPortal
  portalMaxDaysOut
  availabilityReportId
  prePricingEnabled
  priceLabels {
    priceLabelId
    name
    flatPrice
    isDefault
  }
  portalAutoAcknowledge
  portalAutoAllocate
  portalAutoAllocateStrategy
  portalCheckoutOrderStatus
  deliveryBlackouts {
    ...PortalDeliveryBlackoutFields
  }
  customDomains {
    ...PortalCustomDomainFields
  }
  primaryCustomDomain
  helpContact {
    ...PortalHelpContactFields
  }
  checkoutMethod
  orderContact {
    ...PortalOrderContactFields
  }
}`);
export const TenantByCompanySlugDocument = new TypedDocumentString(`
    query TenantByCompanySlug($slug: String!) {
  tenantByCompanySlug(slug: $slug) {
    companySlug
    tenantId
  }
}
    `);
export const TenantByPortalHostDocument = new TypedDocumentString(`
    query TenantByPortalHost($host: String!) {
  tenantByPortalHost(host: $host) {
    tenantId
    host
    companySlug
    isCustomDomain
  }
}
    `);
export const GetPortalBrandingBySlugDocument = new TypedDocumentString(`
    query GetPortalBrandingBySlug($slug: String!) {
  portalBrandingBySlug(slug: $slug) {
    ...PortalPublicBrandingFields
  }
}
    fragment PortalPublicBrandingFields on PortalPublicBranding {
  displayName
  tagline
  logoUrl
  primaryColorHex
  signInPanel {
    body
    headline
    imageUrl
    linkLabel
    linkUrl
  }
}`);
export const GetPortalBrandingByHostDocument = new TypedDocumentString(`
    query GetPortalBrandingByHost($host: String!) {
  portalBrandingByHost(host: $host) {
    ...PortalPublicBrandingFields
  }
}
    fragment PortalPublicBrandingFields on PortalPublicBranding {
  displayName
  tagline
  logoUrl
  primaryColorHex
  signInPanel {
    body
    headline
    imageUrl
    linkLabel
    linkUrl
  }
}`);
export const GetCustomerPortalSettingsDocument = new TypedDocumentString(`
    query GetCustomerPortalSettings($tenantId: String!) {
  customerPortalSettings(tenantId: $tenantId) {
    portalEnabled
    minimumOrderAmount
    catalogDisplayMode
    catalogChipSource
    availabilityMinGrade
    availabilityLocationId
    availabilityLocationIds
    includeSellableHardGoods
    showGradeOnPortal
    prePricingEnabled
    buyerContactEditingEnabled
    buyerRetailPriceEditingEnabled
    checkoutMethod
    orderContact {
      ...PortalOrderContactFields
    }
    helpContact {
      ...PortalHelpContactFields
    }
    gradeLabels {
      ...TenantGradeLabel
    }
  }
}
    fragment PortalHelpContactFields on PortalHelpContactData {
  name
  email
}
fragment PortalOrderContactFields on PortalOrderContactData {
  name
  phone
}
fragment TenantGradeLabel on TenantGradeLabelData {
  grade
  label
}`);
export const GetPortalAccountDocument = new TypedDocumentString(`
    query GetPortalAccount($tenantId: String!) {
  customerPortalAccount(tenantId: $tenantId) {
    ...PortalAccountFields
  }
}
    fragment PortalAccountFields on CustomerPortalAccountData {
  customerId
  name
  erpId
  termsId
  priceGroupId
  effectiveOrderEntryUnit
  effectivePriceEntryUnit
  shipFromLocations {
    name
  }
  orderSubmitter {
    ...OrderSubmitter
  }
  billingAddresses {
    ...Address
  }
  locations {
    id
    code
    name
    address {
      ...Address
    }
    salesPeople {
      ...SalesPerson
    }
  }
  contacts {
    id
    type
    firstName
    lastName
    title
    phoneNumbers {
      type
      value
    }
    emailAddresses {
      type
      value
    }
  }
  salesPeople {
    ...SalesPerson
  }
}
fragment OrderSubmitter on OrderSubmitterData {
  name
  phone
  email
}
fragment Address on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment SalesPerson on SalesPersonData {
  emailAddress {
    type
    value
  }
}`);
export const GetCustomerPortalSellableHardgoodsDocument = new TypedDocumentString(`
    query GetCustomerPortalSellableHardgoods($tenantId: String!, $first: Int, $after: String, $where: MaterialItemDocumentFilterInput, $order: [MaterialItemDocumentSortInput!]) {
  customerPortalSellableHardgoods(
    tenantId: $tenantId
    first: $first
    after: $after
    where: $where
    order: $order
  ) {
    nodes {
      ...PortalSellableHardgood
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment PortalReadyDateBucketFields on PortalReadyDateBucket {
  readyDate
  readyWeek
  readyWeekLabel
  readyWeekIndex
  availableQuantity
  cumulativeAvailableQuantity
}
fragment PortalSellableHardgood on MaterialItemDocument {
  id
  erpId
  name
  description
  itemType
  category
  isOrganic
  availableQuantity
  availableNowQuantity
  availabilityByReadyDate {
    ...PortalReadyDateBucketFields
  }
  readyDate
  readyWeek
  materialImage {
    imageUrl
  }
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetCustomerPortalEligibleDeliveryDatesDocument = new TypedDocumentString(`
    query GetCustomerPortalEligibleDeliveryDates($tenantId: String!, $locationId: UUID, $isPreorder: Boolean) {
  customerPortalEligibleDeliveryDates(
    tenantId: $tenantId
    locationId: $locationId
    isPreorder: $isPreorder
  ) {
    restrictionActive
    enforcedAtCheckout
    earliestEligibleDate
    dates {
      date
      isEligible
      ineligibleReason
    }
  }
}
    `);
export const GetPortalCartFreightDocument = new TypedDocumentString(`
    query GetPortalCartFreight($locationId: UUID!, $subtotal: Decimal!) {
  customerPortalCartFreight(locationId: $locationId, subtotal: $subtotal) {
    amount
    type
    value
  }
}
    `);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetPortalItems: build.query<GetPortalItemsQuery, GetPortalItemsQueryVariables>({
      query: (variables) => ({ document: GetPortalItemsDocument, variables })
    }),
    GetPortalItemsByIds: build.query<GetPortalItemsByIdsQuery, GetPortalItemsByIdsQueryVariables>({
      query: (variables) => ({ document: GetPortalItemsByIdsDocument, variables })
    }),
    GetPortalCartLineShippingUoms: build.query<GetPortalCartLineShippingUomsQuery, GetPortalCartLineShippingUomsQueryVariables>({
      query: (variables) => ({ document: GetPortalCartLineShippingUomsDocument, variables })
    }),
    GetPortalItemPrice: build.query<GetPortalItemPriceQuery, GetPortalItemPriceQueryVariables>({
      query: (variables) => ({ document: GetPortalItemPriceDocument, variables })
    }),
    GetPortalItemPrices: build.query<GetPortalItemPricesQuery, GetPortalItemPricesQueryVariables>({
      query: (variables) => ({ document: GetPortalItemPricesDocument, variables })
    }),
    GetPortalPriceGroup: build.query<GetPortalPriceGroupQuery, GetPortalPriceGroupQueryVariables | void>({
      query: (variables) => ({ document: GetPortalPriceGroupDocument, variables })
    }),
    GetPortalPriceLevels: build.query<GetPortalPriceLevelsQuery, GetPortalPriceLevelsQueryVariables | void>({
      query: (variables) => ({ document: GetPortalPriceLevelsDocument, variables })
    }),
    GetPortalItemAvailability: build.query<GetPortalItemAvailabilityQuery, GetPortalItemAvailabilityQueryVariables>({
      query: (variables) => ({ document: GetPortalItemAvailabilityDocument, variables })
    }),
    GetPortalItemGradeAvailability: build.query<GetPortalItemGradeAvailabilityQuery, GetPortalItemGradeAvailabilityQueryVariables>({
      query: (variables) => ({ document: GetPortalItemGradeAvailabilityDocument, variables })
    }),
    GetPortalFavoritesLists: build.query<GetPortalFavoritesListsQuery, GetPortalFavoritesListsQueryVariables>({
      query: (variables) => ({ document: GetPortalFavoritesListsDocument, variables })
    }),
    GetPortalFavoritesList: build.query<GetPortalFavoritesListQuery, GetPortalFavoritesListQueryVariables>({
      query: (variables) => ({ document: GetPortalFavoritesListDocument, variables })
    }),
    GetPortalCart: build.query<GetPortalCartQuery, GetPortalCartQueryVariables>({
      query: (variables) => ({ document: GetPortalCartDocument, variables })
    }),
    GetPortalCustomerOrders: build.query<GetPortalCustomerOrdersQuery, GetPortalCustomerOrdersQueryVariables | void>({
      query: (variables) => ({ document: GetPortalCustomerOrdersDocument, variables })
    }),
    GetPortalCustomerOrderLines: build.query<GetPortalCustomerOrderLinesQuery, GetPortalCustomerOrderLinesQueryVariables | void>({
      query: (variables) => ({ document: GetPortalCustomerOrderLinesDocument, variables })
    }),
    GetPortalSettings: build.query<GetPortalSettingsQuery, GetPortalSettingsQueryVariables | void>({
      query: (variables) => ({ document: GetPortalSettingsDocument, variables })
    }),
    TenantByCompanySlug: build.query<TenantByCompanySlugQuery, TenantByCompanySlugQueryVariables>({
      query: (variables) => ({ document: TenantByCompanySlugDocument, variables })
    }),
    TenantByPortalHost: build.query<TenantByPortalHostQuery, TenantByPortalHostQueryVariables>({
      query: (variables) => ({ document: TenantByPortalHostDocument, variables })
    }),
    GetPortalBrandingBySlug: build.query<GetPortalBrandingBySlugQuery, GetPortalBrandingBySlugQueryVariables>({
      query: (variables) => ({ document: GetPortalBrandingBySlugDocument, variables })
    }),
    GetPortalBrandingByHost: build.query<GetPortalBrandingByHostQuery, GetPortalBrandingByHostQueryVariables>({
      query: (variables) => ({ document: GetPortalBrandingByHostDocument, variables })
    }),
    GetCustomerPortalSettings: build.query<GetCustomerPortalSettingsQuery, GetCustomerPortalSettingsQueryVariables>({
      query: (variables) => ({ document: GetCustomerPortalSettingsDocument, variables })
    }),
    GetPortalAccount: build.query<GetPortalAccountQuery, GetPortalAccountQueryVariables>({
      query: (variables) => ({ document: GetPortalAccountDocument, variables })
    }),
    GetCustomerPortalSellableHardgoods: build.query<GetCustomerPortalSellableHardgoodsQuery, GetCustomerPortalSellableHardgoodsQueryVariables>({
      query: (variables) => ({ document: GetCustomerPortalSellableHardgoodsDocument, variables })
    }),
    GetCustomerPortalEligibleDeliveryDates: build.query<GetCustomerPortalEligibleDeliveryDatesQuery, GetCustomerPortalEligibleDeliveryDatesQueryVariables>({
      query: (variables) => ({ document: GetCustomerPortalEligibleDeliveryDatesDocument, variables })
    }),
    GetPortalCartFreight: build.query<GetPortalCartFreightQuery, GetPortalCartFreightQueryVariables>({
      query: (variables) => ({ document: GetPortalCartFreightDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetPortalItemsQuery, useLazyGetPortalItemsQuery, useGetPortalItemsByIdsQuery, useLazyGetPortalItemsByIdsQuery, useGetPortalCartLineShippingUomsQuery, useLazyGetPortalCartLineShippingUomsQuery, useGetPortalItemPriceQuery, useLazyGetPortalItemPriceQuery, useGetPortalItemPricesQuery, useLazyGetPortalItemPricesQuery, useGetPortalPriceGroupQuery, useLazyGetPortalPriceGroupQuery, useGetPortalPriceLevelsQuery, useLazyGetPortalPriceLevelsQuery, useGetPortalItemAvailabilityQuery, useLazyGetPortalItemAvailabilityQuery, useGetPortalItemGradeAvailabilityQuery, useLazyGetPortalItemGradeAvailabilityQuery, useGetPortalFavoritesListsQuery, useLazyGetPortalFavoritesListsQuery, useGetPortalFavoritesListQuery, useLazyGetPortalFavoritesListQuery, useGetPortalCartQuery, useLazyGetPortalCartQuery, useGetPortalCustomerOrdersQuery, useLazyGetPortalCustomerOrdersQuery, useGetPortalCustomerOrderLinesQuery, useLazyGetPortalCustomerOrderLinesQuery, useGetPortalSettingsQuery, useLazyGetPortalSettingsQuery, useTenantByCompanySlugQuery, useLazyTenantByCompanySlugQuery, useTenantByPortalHostQuery, useLazyTenantByPortalHostQuery, useGetPortalBrandingBySlugQuery, useLazyGetPortalBrandingBySlugQuery, useGetPortalBrandingByHostQuery, useLazyGetPortalBrandingByHostQuery, useGetCustomerPortalSettingsQuery, useLazyGetCustomerPortalSettingsQuery, useGetPortalAccountQuery, useLazyGetPortalAccountQuery, useGetCustomerPortalSellableHardgoodsQuery, useLazyGetCustomerPortalSellableHardgoodsQuery, useGetCustomerPortalEligibleDeliveryDatesQuery, useLazyGetCustomerPortalEligibleDeliveryDatesQuery, useGetPortalCartFreightQuery, useLazyGetPortalCartFreightQuery } = injectedRtkApi;
